export {
  ELEVATION_ATTR,
  ELEVATION_SELECTOR,
  getElevation,
  useCurrentElevation,
  registerClickOutsideHandler,
  unregisterClickOutsideHandler,
  useClickOutsideHandler,
  getHighestVisibleElevation,
  reset,
} from './src/layerManager';

export { useCallbackRef } from './src/useCallbackRef';
